import { UtilService } from './../../share/util/util.service';
import { FormControl, Validators } from '@angular/forms';
import { AuthenticateService } from './../../share/authenticate/authenticate.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ValidationService } from '../../share/validation/validation.service';
import { MsgService } from '../../share/msg/msg.service';
import * as MSG from '../../share/msg/msg';
import { MailchangeService } from './mailchange.service';
import { MailchangeIf } from './mailchangeIf';
import { Subscription } from 'rxjs';

enum Mode {
  'newMailSet',
  'newMailVerify',
}

@Component({
  selector: 'app-mailchange',
  templateUrl: './mailchange.component.html',
  styleUrls: ['./mailchange.component.css']
})
export class MailchangeComponent implements OnInit, OnDestroy {
  Mode: typeof Mode = Mode;
  currentMode = Mode.newMailSet;
  labelPageTitle = 'メールアドレス変更';
  labelNewMail = '新しいメールアドレス';
  labelNewMailConfirm = '新しいメールアドレスの確認';
  labelVerifyCode = '検証コード';
  newMail = new FormControl('', [Validators.email]);
  newMailConfirm = new FormControl('', [Validators.email]);
  verifyCode = new FormControl('', [Validators.required, Validators.maxLength(10)]);

  subHttpClients = new Subscription();

  constructor(
    public authServ: AuthenticateService,
    public validationServ: ValidationService,
    public msgServ: MsgService,
    private utilServ: UtilService,
    public ownServ: MailchangeService,
  ) { }

  ngOnInit() {
    this.utilServ.uUI.setTitleBar(this.labelPageTitle);
  }

  ngOnDestroy() {
    // Http通信を一括キャンセル
    this.subHttpClients.unsubscribe();
  }

  public validationBeforeUpdateNewMail(): boolean {
    this.validationServ.validationInvalid = false;

    this.newMail.markAsDirty();
    this.validationServ.formValidation(this.newMail, this.labelNewMail);
    this.newMailConfirm.markAsDirty();
    this.validationServ.formValidation(this.newMailConfirm, this.labelNewMailConfirm);
    /** 新パスワードと確認パスワードの一致確認 */
    if (!this.validationServ.validationInvalid) {
      if (this.newMail.value !== this.newMailConfirm.value) {
        this.newMailConfirm.setErrors({'notEqual2Mails': true});
        this.msgServ.warning(MSG.WARNING.TWO_MAIL_DIFFERENT, '');
        this.validationServ.validationInvalid = true;
      }
    }

    return this.validationServ.validationInvalid;
  }

  public validationBeforeVerifyCode(): boolean {
    this.validationServ.validationInvalid = false;

    this.verifyCode.markAsDirty();
    this.validationServ.formValidation(this.verifyCode, this.labelVerifyCode);

    return this.validationServ.validationInvalid;
  }

  public updateMail(): void {
    if (this.validationBeforeUpdateNewMail()) {
      return;
    }
    this.authServ.updateMail(this.newMail.value);
    this.currentMode = Mode.newMailVerify;
  }

  public verifyNewMail(): void {
    if (this.validationBeforeVerifyCode()) {
      return;
    }
    this.authServ.verifyNewMail(this.verifyCode.value)
    .then(verifyOk => {
      // 再度トークンからmail取得
      this.subHttpClients.add(this.authServ.getLatestCurrentUserData().subscribe(
        response => {
          const res = response as any;
          if (res && res.attributes && res.attributes.email) {
            // DB更新
            const data: MailchangeIf.UpdModel = {
              username: this.authServ.username,
              mail: res.attributes.email
            };
            this.subHttpClients.add(this.ownServ.putMail(data).subscribe(
              dbUpdateOk => {}
            ));
          } else {
            // トークンにmail情報が無い
            throw new Error('Not exist attributes.mail in current token.');
          }
        }
      ));
    })
    .catch(varifyNg => console.error(varifyNg));
  }
}
